export const getPageNameHandle = (pageName: string) => ({
	pageName,
});

export const hasPageNameHandle = (
	handle: unknown,
): handle is { pageName: string } => {
	return (
		handle !== null &&
		typeof handle === "object" &&
		"pageName" in handle &&
		typeof handle.pageName === "string"
	);
};
